// Conversation transcript. Messages already arrive with the conversation (GET /api/conversations),
// so this only normalises them for the transcript view — no extra round trip.
export const getConversationTranscript = async (conversationId, messages = []) => {
  if (!conversationId) throw new Error("Conversation ID is required");
  const transcript = messages.map((message, index) => ({
    id: message.id || `${conversationId}-${index + 1}`,
    from: message.from,
    text: message.text,
    createdAt: message.createdAt ? new Date(message.createdAt).toLocaleString() : "",
  }));
  return { success: true, data: transcript };
};
